class ExpandableText extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Find all expandable text elements within this component
    const textElements = this.querySelectorAll('[data-expandable-text]');
    
    textElements.forEach(textElement => {
      const button = textElement.parentNode.querySelector('[data-expand-button]');
      const learnMoreText = button.querySelector('[data-learn-more-text]');
      const readLessText = button.querySelector('[data-read-less-text]');
      
      // Check if text needs truncation
      this.checkTextTruncation(textElement, button);
      
      // Add click event listener
      button.addEventListener('click', () => {
        const isExpanded = textElement.classList.contains('expanded');
        
        if (isExpanded) {
          // Collapse text
          textElement.classList.remove('expanded');
          button.setAttribute('aria-expanded', 'false');
          learnMoreText.style.display = 'inline';
          readLessText.style.display = 'none';
        } else {
          // Expand text
          textElement.classList.add('expanded');
          button.setAttribute('aria-expanded', 'true');
          learnMoreText.style.display = 'none';
          readLessText.style.display = 'inline';
        }
      });
    });
  }

  checkTextTruncation(textElement, button) {
    // Temporarily remove line clamp to measure full height
    const originalDisplay = textElement.style.display;
    const originalLineClamp = textElement.style.webkitLineClamp;
    
    textElement.style.display = 'block';
    textElement.style.webkitLineClamp = 'unset';
    
    const fullHeight = textElement.scrollHeight;
    
    // Restore line clamp
    textElement.style.display = originalDisplay;
    textElement.style.webkitLineClamp = originalLineClamp;
    
    const clampedHeight = textElement.scrollHeight;
    
    // Show button only if text is truncated (content is taller than 5 lines)
    if (fullHeight > clampedHeight) {
      button.style.display = 'block';
    } else {
      button.style.display = 'none';
    }
  }
}

// Register the custom element
customElements.define('expandable-text', ExpandableText);

// Auto-initialize for existing elements
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.multi-column-item__text p').forEach(p => {
    // fix clamp dots cutting off descenders by adding spacer after second <br>
    const brs = p.querySelectorAll('br');
    if (brs.length > 1) {
      const secondBr = brs[1]; // zero-based index
      const spacer = document.createElement('span');
      spacer.style.display = 'none'; 
      spacer.style.height = '1em';
      secondBr.replaceWith(spacer);
    }
  });
  // Initialize expandable text for elements not wrapped in custom element
  const containers = document.querySelectorAll('.multi-column-item__text-container');
  containers.forEach(container => {
    if (!container.closest('expandable-text')) {
      const textElement = container.querySelector('[data-expandable-text]');
      const button = container.querySelector('[data-expand-button]');
      
      if (textElement && button) {
        // Replace the 2nd <br> with a block spacer to preserve line break without clamp dots
        const para = textElement.querySelector('p');
        if (para) {
          const breaks = para.querySelectorAll('br');
          if (breaks.length > 1) {
            const br2 = breaks[1];
            const spacer = document.createElement('span');
            spacer.style.display = 'block';
            spacer.style.height = '1em';
            br2.replaceWith(spacer);
          }
        }
        const learnMoreText = button.querySelector('[data-learn-more-text]');
        const readLessText = button.querySelector('[data-read-less-text]');
        
        // Check if text needs truncation
        checkTextTruncation(textElement, button);
        
        // Add click event listener
        button.addEventListener('click', () => {
          const isExpanded = textElement.classList.contains('expanded');
          
          if (isExpanded) {
            // Collapse text
            textElement.classList.remove('expanded');
            button.setAttribute('aria-expanded', 'false');
            learnMoreText.style.display = 'inline';
            readLessText.style.display = 'none';
          } else {
            // Expand text
            textElement.classList.add('expanded');
            button.setAttribute('aria-expanded', 'true');
            learnMoreText.style.display = 'none';
            readLessText.style.display = 'inline';
          }
        });
      }
    }
  });
});

function checkTextTruncation(textElement, button) {
  const isClamped = textElement.scrollHeight > textElement.clientHeight;
  // Show button only if text is truncated
  if (isClamped) {
    button.style.display = 'block';
  } else {
    button.style.display = 'none';
  }
}
